import { render } from "./SectionsDashboardSectionSquareItem.vue?vue&type=template&id=6c993318"
import script from "./SectionsDashboardSectionSquareItem.vue?vue&type=script&lang=js"
export * from "./SectionsDashboardSectionSquareItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__